import { useCallback, useMemo, useReducer } from 'react';

import { DRAWER_STACK_ACTIONS } from '../constants';

const createInitialState = () => ({
  stack: [],
  nextKey: 0
});

const reducer = (state, action) => {
  switch (action.type) {
    case DRAWER_STACK_ACTIONS.Open: {
      const nextKey = state.nextKey + 1;
      const entry = {
        key: nextKey,
        type: action.drawerType,
        props: action.props
      };

      return {
        stack: [...state.stack, entry],
        nextKey
      };
    }
    case DRAWER_STACK_ACTIONS.ReplaceTop: {
      if (state.stack.length === 0) {
        return state;
      }
      const nextKey = state.nextKey + 1;
      const entry = {
        key: nextKey,
        type: action.drawerType,
        props: action.props
      };

      return {
        stack: [...state.stack.slice(0, -1), entry],
        nextKey
      };
    }
    case DRAWER_STACK_ACTIONS.Close: {
      return {
        ...state,
        stack: state.stack.filter(entry => entry.key !== action.key)
      };
    }
    case DRAWER_STACK_ACTIONS.Clear: {
      return {
        ...state,
        stack: []
      };
    }
    default:
      return state;
  }
};

export const useDrawerStack = () => {
  const [state, dispatch] = useReducer(reducer, undefined, createInitialState);

  const openDrawer = useCallback((drawerType, props = {}) => {
    dispatch({ type: DRAWER_STACK_ACTIONS.Open, drawerType, props });
  }, []);

  const replaceTopDrawer = useCallback((drawerType, props = {}) => {
    dispatch({ type: DRAWER_STACK_ACTIONS.ReplaceTop, drawerType, props });
  }, []);

  const closeDrawer = useCallback(key => {
    dispatch({ type: DRAWER_STACK_ACTIONS.Close, key });
  }, []);

  const clearStack = useCallback(() => {
    dispatch({ type: DRAWER_STACK_ACTIONS.Clear });
  }, []);

  return useMemo(
    () => ({
      stack: state.stack,
      openDrawer,
      replaceTopDrawer,
      closeDrawer,
      clearStack
    }),
    [state.stack, openDrawer, replaceTopDrawer, closeDrawer, clearStack]
  );
};
